module.exports = __webpack_public_path__ + "img/info.4f2a7523.svg";